import { processUserAgent } from '@/constants';
import { Bridge } from './bridge';

/**
 * Check is in iOS/Android browser like Safari or Chrome.
 * https://www.cnblogs.com/guobin-/p/16670438.html
 * @returns item of  ["isIos", "isAndroid", "isOther"]
 */
const deviceSource = {
  get ua() {
    return navigator.userAgent;
  },
  deviceVerificaMethodList: ['isIos', 'isAndroid', 'isOther'],
  isIos() {
    return !!this.ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  },
  isAndroid() {
    return this.ua.indexOf('Android') > -1 || this.ua.indexOf('Linux') > -1;
  },
  isOther() {
    return !this.isAndroid() && !this.isIos();
  },
  get deviceSystem() {
    const enumDeviceVerificaMethod = {
      isIos: this.isIos(),
      isAndroid: this.isAndroid(),
      isOther: this.isOther()
    };
    return this.deviceVerificaMethodList.filter(
      device => enumDeviceVerificaMethod[device]
    )[0];
  }
};

/**
 * Determine browser device
 */
const browserDiscriminate = {
  // If true is returned, it is wechat built-in browser, false is not.
  isWechat() {
    // Gets the user-agaent identifier header
    const ua = deviceSource.ua.toLowerCase();
    // Check whether the ua and wechat browser ID headers match
    return ua.match(/micromessenger/i);
  },
  // If true is returned, the enterprise wechat built-in browser, false is not.
  isWorkWechat() {
    // Gets the user-agaent identifier header
    const ua = deviceSource.ua.toLowerCase();
    // Check whether the ua and wechat browser ID headers match
    return ua.match(/micromessenger/i) && ua.match(/wxwork/i);
  }
};

// Determine whether it is in the APP browser environment (Webview)
const isAppEnv = () => 'appPlatform' in processUserAgent(navigator.userAgent);
// Confirm it is iOS webview
const isAppEnvIos = () =>
  processUserAgent(navigator.userAgent).appPlatform === 'iOS';
// Confirm it is Android webview
const isAppEnvAndroid = () =>
  processUserAgent(navigator.userAgent).appPlatform === 'Android';
// Get App deviceId
const getDeviceId = async () => {
  const { deviceId } = await Bridge.callFnVal('getDeviceId', {});
  return deviceId;
};

export {
  deviceSource,
  browserDiscriminate,
  isAppEnv,
  isAppEnvIos,
  isAppEnvAndroid,
  getDeviceId
};
